export { default as EventsPageContainer } from "./events_page_container";
